import {
  ToggleButton as ReactAriaToggleButton,
  ToggleButtonGroup as ReactAriaToggleButtonGroup,
  type ToggleButtonGroupProps as ReactAriaToggleButtonGroupProps,
  type ToggleButtonProps as ReactAriaToggleButtonProps,
} from "react-aria-components";

import { cn, cv, type VariantProps } from "../utils";
import { ncButtonClasses } from "./nc-button";

const toggleButtonGroupVariants = cv("isolate", {
  variants: {
    variant: {
      horizontal:
        "flex *:not-first-of-type:-ml-[2px] *:not-first-of-type:rounded-l-none *:not-last-of-type:rounded-r-none",
      vertical:
        "grid *:not-first-of-type:-mt-[2px] *:not-first-of-type:rounded-t-none *:not-last-of-type:rounded-b-none",
    },
  },
  defaultVariants: {
    variant: "horizontal",
  },
});

interface NcToggleButtonGroupProps
  extends ReactAriaToggleButtonGroupProps,
    VariantProps<typeof toggleButtonGroupVariants> {}

const NcToggleButtonGroup = ({
  orientation,
  variant,
  className,
  ...props
}: NcToggleButtonGroupProps) => {
  const groupOrientation = orientation ?? variant ?? "horizontal";
  return (
    <ReactAriaToggleButtonGroup
      orientation={groupOrientation}
      className={cn(toggleButtonGroupVariants({ variant }), className)}
      {...props}
    />
  );
};

const NcToggleButton = ({ ...props }: ReactAriaToggleButtonProps) => {
  return (
    <ReactAriaToggleButton
      className={cn(
        ncButtonClasses.base,
        ncButtonClasses.variant.default,
        "data-focused:z-10 data-hovered:z-10 data-selected:z-10"
      )}
      {...props}
    />
  );
};

NcToggleButtonGroup.ToggleButton = NcToggleButton;

export { NcToggleButtonGroup };
